import React from 'react';
import '../styles/MentionsLegales.css';

function MentionsLegales() {
  return (
    <div className="mentions-container">
      <div className="mentions-hero">
        <h1>⚖️ Mentions Légales</h1>
        <p>Informations légales concernant le site ASIFC</p>
      </div>

      <div className="mentions-content">
        <section className="mentions-section">
          <h2>1. Éditeur du site</h2>
          <div className="info-box">
            <p><strong>Nom de l'association :</strong> ASIFC - Association de Solidarité Internationale France-Comores</p>
            <p><strong>Forme juridique :</strong> Association loi 1901</p>
            <p><strong>Siège social :</strong> Rhône-Alpes, France</p>
            <p><strong>Email :</strong> <a href="mailto:asifc.rhone@gmail.com">asifc.rhone@gmail.com</a></p>
            <p><strong>Directeur de la publication :</strong> Président de l'ASIFC</p>
          </div>
        </section>

        <section className="mentions-section">
          <h2>2. Hébergement du site</h2>
          <div className="info-box">
            <p><strong>Hébergeur :</strong> [Nom de l'hébergeur]</p>
            <p><strong>Adresse :</strong> [Adresse de l'hébergeur]</p>
            <p><strong>Téléphone :</strong> [Numéro de téléphone]</p>
          </div>
        </section>

        <section className="mentions-section">
          <h2>3. Propriété intellectuelle</h2>
          <p>
            L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur 
            et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les 
            documents téléchargeables et les représentations iconographiques et photographiques.
          </p>
          <p>
            La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est 
            formellement interdite sauf autorisation expresse du directeur de la publication.
          </p>
        </section>

        <section className="mentions-section">
          <h2>4. Données personnelles</h2>
          <p>
            Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi "Informatique 
            et Libertés" du 6 janvier 1978 modifiée, vous disposez d'un droit d'accès, de rectification, de 
            suppression et d'opposition aux données personnelles vous concernant.
          </p>
          <p>
            Pour exercer ces droits, vous pouvez nous contacter à l'adresse : 
            <a href="mailto:asifc.rhone@gmail.com"> asifc.rhone@gmail.com</a>
          </p>
          <p>
            Pour plus d'informations sur la gestion de vos données personnelles, consultez notre 
            <a href="/politique-confidentialite"> Politique de Confidentialité</a>.
          </p>
        </section>

        <section className="mentions-section">
          <h2>5. Cookies</h2>
          <p>
            Ce site utilise des cookies pour améliorer l'expérience utilisateur et réaliser des statistiques 
            de visite. Vous pouvez gérer vos préférences de cookies via la bannière de consentement qui 
            s'affiche lors de votre première visite.
          </p>
          <h3>Types de cookies utilisés :</h3>
          <ul>
            <li><strong>Cookies nécessaires :</strong> Indispensables au fonctionnement du site</li>
            <li><strong>Cookies analytiques :</strong> Permettent de mesurer l'audience du site</li>
            <li><strong>Cookies marketing :</strong> Utilisés pour personnaliser les publicités (si acceptés)</li>
          </ul>
        </section>

        <section className="mentions-section">
          <h2>6. Liens hypertextes</h2>
          <p>
            Le site peut contenir des liens vers d'autres sites internet. L'ASIFC n'exerce aucun contrôle 
            sur ces sites et décline toute responsabilité quant à leur contenu.
          </p>
          <p>
            La mise en place d'un lien hypertexte vers notre site nécessite une autorisation préalable. 
            Pour toute demande, veuillez nous contacter.
          </p>
        </section>

        <section className="mentions-section">
          <h2>7. Responsabilité</h2>
          <p>
            L'ASIFC s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. 
            Toutefois, l'association ne peut garantir l'exactitude, la précision ou l'exhaustivité des 
            informations mises à disposition.
          </p>
          <p>
            En conséquence, l'ASIFC décline toute responsabilité pour :
          </p>
          <ul>
            <li>Toute imprécision, inexactitude ou omission portant sur des informations disponibles sur le site</li>
            <li>Tout dommage résultant d'une intrusion frauduleuse d'un tiers ayant entraîné une modification des informations</li>
            <li>Tout dysfonctionnement du site ou impossibilité d'accès temporaire</li>
          </ul>
        </section>

        <section className="mentions-section">
          <h2>8. Droit applicable</h2>
          <p>
            Les présentes mentions légales sont soumises au droit français. En cas de litige, et à défaut 
            d'accord amiable, le litige sera porté devant les tribunaux français conformément aux règles 
            de compétence en vigueur.
          </p>
        </section>

        <section className="mentions-section">
          <h2>9. Crédits</h2>
          <div className="info-box">
            <p><strong>Conception et développement :</strong> ASIFC</p>
            <p><strong>Icônes :</strong> Emojis natifs</p>
            <p><strong>Photos :</strong> ASIFC et partenaires (sauf mention contraire)</p>
          </div>
        </section>

        <section className="mentions-section">
          <h2>10. Contact</h2>
          <p>
            Pour toute question concernant les mentions légales, vous pouvez nous contacter :
          </p>
          <div className="contact-box">
            <p><strong>📧 Email :</strong> <a href="mailto:asifc.rhone@gmail.com">asifc.rhone@gmail.com</a></p>
            <p><strong>📍 Adresse :</strong> ASIFC, Rhône-Alpes, France</p>
            <p><strong>📄 Documents :</strong> 
              <a href="/politique-confidentialite"> Politique de Confidentialité</a>
            </p>
          </div>
        </section>

        <section className="mentions-section last">
          <p className="update-date">
            <em>Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</em>
          </p>
        </section>
      </div>
    </div>
  );
}

export default MentionsLegales;